import {
  REQUEST_STATUS_NAMES,
  type RequestStatusNameValue,
} from '@outkeep/shared';

// StatusName = StatusId
export enum RequestStatuses {
  New = 1, // Новая
  Completed = 3, // Выполнено
  EditQuery = 6, // Запрос на редактирование
  OnEdit = 7, // На редактировании
  CheckFinished = 8, // Проверка завершена
  RequestIsWaitingForCheck = 9, // Заявка ждет проверки
  InWork = 10, // В работе
  Given = 11, // Выдано
  SLSWasAppointed = 12, // Назначен специалист по установке
  MistakeInRequest = 13, // Ошибка в заявке
  Cancelled = 14, // Отменена
  Rejected = 15, // Отклонена
  RejectedLocal = 16, // Отклонена
}

export type RequestStatus = {
  id: RequestStatuses;
  name: RequestStatusName;
  sort?: number;
  color: string;
  readonly: boolean;
  createdId?: number;
  createdAt: Date;
  updatedAt: Date;
  formData?: any;
};

export const RequestStatusName = REQUEST_STATUS_NAMES;
export type RequestStatusName = RequestStatusNameValue;

export type QualityControlStatus = {
  id: number;
  name: string;
};
